import { Marker } from 'react-leaflet';
import { divIcon } from 'leaflet';

// const useMapEvents = dynamic(() => import("react-leaflet").then(mod => mod.useMapEvents), { ssr: false });

export default function MapMarker({ position, mapRef }) {
  const ICON = divIcon({
    html: `<span></span>`,
    className: `flex rounded-full border-[8px] bg-white
     border-primary duration-100`,
    iconSize: [25, 25],
  });
  // const [marker, setMarker] = useState(position);

  // return <MapSingleMarker item={position} mapRef={mapRef} />;
  return <Marker icon={ICON} position={position}></Marker>;
}

// const MapSingleMarker = dynamic(() => import("./MapSingleMarker"), {
//   ssr: false,
// });
